import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BellOutlined,
  DashboardOutlined,
  PoweroffOutlined,
  SolutionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Avatar, Button, Dropdown } from "antd";
import { initiateLogin, truncateByCharacterCount } from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../../store";
import { logoutUser } from "../../redux/services/customerService";
import ProfilePopup from "./ProfilePopup";

const HeaderRightSide = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { userInfo, collapsed } = useSelector(
    (state: RootState) => state.userInfo
  );

  const [isProfileVisible, setIsProfileVisible] = useState(false);

  const signOut = () => {
    dispatch(logoutUser()).then(() => {
      initiateLogin();
    });
  };

  const handleProfileClick = () => {
    setIsProfileVisible(true);
  };

  const navigate = useNavigate();

  const items: MenuProps["items"] = [
    {
      key: "profile",
      onClick: handleProfileClick,
      label: (
        <span>
          <SolutionOutlined /> View Profile
        </span>
      ),
    },
    {
      key: "logout",
      onClick: signOut,
      label: (
        <span>
          <PoweroffOutlined /> Log Out
        </span>
      ),
    }
  ];
  return (
    <div className="collapseDiv">
      <Button
        type="text"
        icon={<BellOutlined className="text-base" />}
        className="mr-10 text-base"
      >
        {/* <span className={collapsed ? '' : 'noShow'}>Notification</span> */}
      </Button>
      <div className="pointer">
        <Dropdown menu={{ items }} trigger={['click']}>
          <div>
            <Avatar
              size={"small"}
              icon={<UserOutlined />}
              className="avatarAdditional"
            >
              {userInfo?.first_name?.[0] ?? ""}
            </Avatar>
            <span
              title={userInfo?.first_name}
              className={collapsed ? "mr-10" : "mr-10 noShow"}
            >
              {truncateByCharacterCount(`${userInfo?.first_name}`)}
            </span>
          </div>
        </Dropdown>
      </div>
      <ProfilePopup
        visible={isProfileVisible}
        onClose={() => setIsProfileVisible(false)}
        user={userInfo}
      />
    </div>
  );
};
export default HeaderRightSide;
